import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("revo_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] p-8" data-testid="admin-login-form">
        <div className="mb-6 flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-revo-green"><Zap className="h-4 w-4 text-navy" fill="currentColor" /></span>
          <span className="font-display text-xl font-extrabold text-white">ChargeRevo Admin</span>
        </div>
        <h1 className="font-display text-2xl font-black text-white">Lead dashboard</h1>
        <p className="mt-1 text-sm text-revo-ice/60">Sign in to view waitlist &amp; business submissions.</p>

        <div className="mt-6 space-y-4">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required data-testid="admin-email" className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-revo-ice/40 focus:border-revo-green focus:outline-none" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required data-testid="admin-password" className="w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-white placeholder:text-revo-ice/40 focus:border-revo-green focus:outline-none" />
        </div>
        {error && <p className="mt-3 text-sm text-red-400" data-testid="admin-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-btn" className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-revo-green py-3 font-bold text-navy transition-transform duration-200 hover:scale-[1.02] disabled:opacity-60">
          <Lock className="h-4 w-4" /> {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
